import { useIntl } from "react-intl";

type ReasonType = { label: string; value: string };

function useReasonTypes(): ReasonType[] {
  const { formatMessage } = useIntl();
  return [
    {
      label: formatMessage({
        id: "inventory.modal.editLot.field-reasonCategory-error",
        defaultMessage: "Error",
      }),
      value: "ERROR",
    },
    {
      label: formatMessage({
        id: "inventory.modal.editLot.field-reasonCategory-wastage",
        defaultMessage: "Wastage",
      }),
      value: "WASTAGE",
    },
    {
      label: formatMessage({
        id: "inventory.modal.editLot.field-reasonCategory-transferToAnotherFacility",
        defaultMessage: "Transfer to Other Facility",
      }),
      value: "TRANSFER_TO_ANOTHER_FACILITY",
    },
    {
      label: formatMessage({
        id: "inventory.modal.editLot.field-reasonCategory-expired",
        defaultMessage: "Expired",
      }),
      value: "EXPIRED",
    },
    {
      label: formatMessage({
        id: "inventory.modal.editLot.field-reasonCategory-other",
        defaultMessage: "Other",
      }),
      value: "OTHER",
    },
  ];
}

export default useReasonTypes;
